import React, {useState} from 'react';
import {
   View,
   Modal,
   TouchableOpacity,
   Image,
   ImageBackground,
   SafeAreaView,
} from 'react-native';
import {selectScreenOrientation} from '../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';

const CustomImageViewer = props => {
   const isLandscapeMode = useSelector(selectScreenOrientation);

   const [modalVisible, setModalVisible] = useState(false);
   const closeModal = () => {
      setModalVisible(false);
   };

   return (
      <Modal
         statusBarTranslucent
         animationType="fade"
         transparent
         visible={true}
         supportedOrientations={['landscape']}>
         <SafeAreaView style={{flex: 1}}>
            <View
               style={{
                  flex: 1,
                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
               }}>
               <TouchableOpacity
                  style={{
                     justifyContent: 'flex-end',
                     alignItems: 'flex-end',
                     marginTop: 26,
                     marginRight: 40,
                  }}
                  onPress={() => {
                     props.onClose();
                  }}>
                  <Image
                     source={require('../assets/cross.png')}
                     style={{
                        height: isLandscapeMode ? 40 : 20,
                        width: isLandscapeMode ? 40 : 20,
                     }}
                  />
               </TouchableOpacity>
               <ImageBackground
                  resizeMode="contain"
                  style={{width: '100%', height: '100%'}}
                  source={{uri: props.imageURL}}
               />
            </View>
         </SafeAreaView>
      </Modal>
   );
};
export default CustomImageViewer;
